import React from 'react';
import { companyData } from '../data';

export default function SchemaMarkup({ type, data }) {
  if (typeof window === 'undefined') return null;

  const origin = window.location.origin;
  let schema = {};

  const defaultOrgSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": companyData.name,
    "image": companyData.logo,
    "telephone": companyData.phone,
    "email": companyData.email,
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "DK",
      "addressLocality": "Danmark"
    },
    "url": origin,
    "logo": companyData.logo
  };

  if (type === 'organization') {
    schema = defaultOrgSchema;
  } else if (type === 'website') {
    schema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": companyData.name,
      "url": origin
    };
  } else if (type === 'service') {
    schema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": data.title,
      "provider": {
        "@type": "LocalBusiness",
        "name": companyData.name,
        "image": companyData.logo,
        "telephone": companyData.phone,
        "email": companyData.email,
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "DK",
          "addressLocality": "Danmark"
        },
        "url": origin
      },
      "description": data.shortDescription,
      "areaServed": "DK"
    };
  } else if (type === 'breadcrumbs') {
    schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": data.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": `${origin}${item.href}`
      }))
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
